<div class="area-list-container" [@slideInOut]="isOpen">
    @if (isOpen === 'areas') {
        <frmg-area-list (projectSelect)="projectSelect($event)" (onDestroyCallback)="saveListState($event)"
                        [initState]="savedState"/>
    }
    @if (isOpen === 'layers') {
        <frmg-layer-sidebar/>
    }
    @if (isOpen === 'bookmarks') {
        <frmg-bookmarks-sidebar [currentProject]="currentProject" [layersState]="layersState" [bbox]="bbox"
                                (onActivate)="activateBookmark($event)"/>
    }
    <div class="area-actions">
        @for (sidebar of sidebarsToOpen; track sidebar) {
            <div class="open-close-handle" [ngClass]="{'open': isOpen === 'out'}" (click)="toggle(sidebar.name)"
                 [matTooltip]="sidebar.tooltip" matTooltipPosition="right">
                <div class="action-button">
                    <inline-svg [src]="sidebar.src" className="project-icon"
                                [ngClass]="{'active': isOpen === sidebar.name}"></inline-svg>
                </div>
            </div>
        }
    </div>
</div>
<div class="map-controls">
    <div class="controls-group">
        <div class="draw-tools-handle">
            <div class="action-button" (click)="openDrawTools()" matTooltip="Drawing mode" matTooltipPosition="left">
                <inline-svg [src]="currentToolIcon + '.svg'" className="project-icon"
                            [ngClass]="{'active': action.includes('draw')}"></inline-svg>
            </div>
            <div class="draw-tools draw-tools-opened" [ngClass]="{'draw-tools-opened': action === 'drawTool'}">
                @for (tool of drawTools; track tool) {
                    <div class="action-button" (click)="setDrawTool(tool)"
                         [matTooltip]="capitalizeFirstLetter(tool)" matTooltipPosition="above">
                        <inline-svg [src]="tool + '.svg'" className="project-icon"
                                    [ngClass]="{'active': currentToolIcon === tool && drawing}"></inline-svg>
                    </div>
                }
            </div>
        </div>
        <div class="horizontal-separator"></div>
        <div class="action-button" (click)="rectangleSelectState()" matTooltip="Rectangle Select Mode"
             matTooltipPosition="left">
            <inline-svg src="draw-rectangle.svg" className="project-icon"
                        [ngClass]="{'active': action === 'rectangleSelect'}"></inline-svg>
        </div>
        <div class="horizontal-separator"></div>
        <div class="action-button" (click)="selectionState()" matTooltip="Select Mode" matTooltipPosition="left">
            <inline-svg src="cursor.svg" className="project-icon"
                        [ngClass]="{'active': action.includes('selection') && action !== 'rectangleSelect'}"></inline-svg>
        </div>
    </div>

    <div class="control-separator"></div>
    <div class="controls-group">
        <div class="action-button" (click)="quickArea()" matTooltip="Show quick info"
             [ngClass]="{'disabled': !currentDrawn || error || currentDrawn.type !== 'Point'}"
             matTooltipPosition="left" [matTooltipDisabled]="!currentDrawn">
            <inline-svg src="report_preview.svg" className="project-icon"></inline-svg>
        </div>
        <div class="horizontal-separator"></div>
        <div class="action-button" (click)="saveDrawnAreas()" matTooltip="Save drawn area"
             [ngClass]="{'disabled': !currentDrawn || error}"
             matTooltipPosition="left" [matTooltipDisabled]="!currentDrawn">
            <inline-svg src="save.svg" className="project-icon"></inline-svg>
        </div>
        <div class="horizontal-separator"></div>
        <div class="action-button" (click)="clearDrawnAreas()" matTooltip="Clear drawn area"
             [ngClass]="{'disabled': !currentDrawn}" matTooltipPosition="left"
             [matTooltipDisabled]="!currentDrawn">
            <inline-svg src="clear-area.svg" className="project-icon"></inline-svg>
        </div>
    </div>
    <div class="control-separator"></div>
    <div class="controls-group">
        <div class="action-button" (click)="saveBookmark()" matTooltip="Save bookmark"
             [ngClass]="{'disabled': !currentProject}"
             matTooltipPosition="left" [matTooltipDisabled]="!currentProject">
            <inline-svg src="add_bookmark.svg" className="project-icon"></inline-svg>
        </div>
    </div>
    <div class="control-separator"></div>
    <div class="controls-group">
        <div class="action-button" (click)="zoomMap('in')" matTooltip="Zoom in" matTooltipPosition="left">
            <inline-svg src="zoom_in.svg" className="project-icon"></inline-svg>
        </div>
        <div class="horizontal-separator"></div>
        <div class="action-button" (click)="zoomMap('out')" matTooltip="Zoom out" matTooltipPosition="left">
            <inline-svg src="zoom_out.svg" className="project-icon"></inline-svg>
        </div>
    </div>

</div>

<div class="quick-preview-container"
     [ngStyle]="isOpen !== 'out' ? {'left.px': 410, 'width': 'calc(100vw - 500px)'} : {'left.px': 10, 'width': 'calc(100vw - 100px)'} ">
    @for (preview of previewArray; track preview) {
        <div class="preview">
            <span (click)="openPreview(preview, $index, $event)">Point {{ previewArray.length - $index }} </span>
            <span class="icon icon-small-close" (click)="discardPreview($index, preview, $event)"
                  matTooltip="Close"></span>
        </div>
    }
</div>

<div class="top-left-container">

    @if (bookmarkActive) {
        <div class="bookmark-info-container">
            <inline-svg src="bookmark.svg" class="project-icon" color="#85BBF3"></inline-svg>
            <span>{{ bookmark?.name }}</span>
            @if (bookmark?.user?.email === currentUser?.email) {
                <inline-svg
                        src="Hamburger_menu.svg"
                        class="item-menu"
                        [matMenuTriggerFor]="actionMenu"
                        #bookmarkMenuTrigger="matMenuTrigger"
                        [color]="bookmarkMenuTrigger.menuOpen ? '#5E84F7' : '#A5B5BD'"
                        hoverColor="#7F8F98"
                        (click)="$event.stopPropagation()"
                ></inline-svg>
                <mat-menu #actionMenu="matMenu" class="action-menu">
                    <button
                            mat-menu-item
                            (click)="editBookmark(bookmark, $event, bookmarkMenuTrigger)"
                            class="menu-slot"
                    >
                        Rename
                    </button>
                    <button
                            mat-menu-item
                            (click)="bulkDelete(bookmark, bookmarkMenuTrigger)"
                            class="menu-slot"
                    >
                        Delete Bookmark
                    </button>
                </mat-menu>
            }
        </div>
    }

    <frmg-address-search (mapDrawEvent)="onDrawEnd($event)"></frmg-address-search>
</div>
<frmg-map [ngClass]="{'map-open': isOpen !== 'out'}" (mapDrawEvent)="onDrawEnd($event)"
          (bboxChanged)="bboxChanged($event)"/>